export default class InformationContentResponseMapper {
  map(response: any) {
    return response;
  }

  unMap(response: any) {
    return response;
  }
}
